import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

const useNameplateCreate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ compressorId, filename, file }) => {
      return queries.nameplates.create.query({ compressorId, filename, file });
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.history.companiesHistory.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useNameplateDelete = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }) => {
      return queries.nameplates.delete.query(id);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.history.companiesHistory.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useNameplateCreate,
  useNameplateDelete,
};
